import type { MatrixClient, MatrixEvent } from "matrix-js-sdk";
import { RoomMemberEvent } from "matrix-js-sdk";
import { useEffect, useState } from "react";

export const useOtherUserIsTyping = ({
  matrixClient,
}: {
  matrixClient: MatrixClient | null;
}) => {
  const [typingUsers, setTypingUsers] = useState<string[]>([]);
  const userId = matrixClient?.getUserId();

  useEffect(() => {
    if (!matrixClient) {
      return;
    }

    const updateTypingState = (event: MatrixEvent) => {
      const currentlyTypingUserIds = event.event.content!.user_ids as string[];
      setTypingUsers(currentlyTypingUserIds);
    };

    matrixClient.on(RoomMemberEvent.Typing, updateTypingState);
    return () => {
      matrixClient.off(RoomMemberEvent.Typing, updateTypingState);
    };
  }, [matrixClient]);

  const otherUserIsTyping = typingUsers.some((id) => id !== userId);
  return { otherUserIsTyping };
};
